<div class="border border-solid border-neutral-200 px-6 py-7 rounded-xl lg:w-4/5 mx-auto ">
    <div class="flex items-center justify-evenly flex-wrap gap-5">
        <div *ngFor="let item of [].constructor(5)" class="dark-overlay animate-pulse block !rounded-2xl h-[80px] lg-min-w-auto min-w-[88px]">
        </div>
    </div>
</div>
